module.exports = __webpack_public_path__ + "img/case4.00343ab4.jpg";